import React, { memo } from "react";
export var FormikStep = memo(function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null, React.Children.toArray(children).map(function (child, index) {
        if (!React.isValidElement(child))
            return null;
        return React.cloneElement(child, { key: "formikStep-key-".concat(index) });
    })));
});
export default FormikStep;
